/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  /* border-bottom: 1px solid ${Palette.PrimaryGray._200}; */
  width: 100%;
  background: #fff;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  position: relative;
`;

export const SearchBox = styled.div`
  flex: 1;
`;
